import React, { useEffect, useState } from 'react';
import { CONSENT_EVENT, readConsent } from './CookieBar';
import { CtaButton, isPrerender } from './parts';

// Phones only (hidden from md up): a slim "Book your free call" bar pinned to the bottom.
// Shows once the visitor has scrolled past the hero's own Book button, hides while the booking
// section is on screen (the calendar is right there), and waits until the cookie bar has been
// answered so the two never overlap. While it can show, html.rb-bookbar adds bottom padding to the
// page (CSS, phones only) so it never covers the end of the footer.
export default function MobileBookBar() {
  const [consented, setConsented] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isPrerender()) return undefined;
    if (readConsent()) setConsented(true);
    const onConsent = () => setConsented(true);
    window.addEventListener(CONSENT_EVENT, onConsent);
    return () => window.removeEventListener(CONSENT_EVENT, onConsent);
  }, []);

  useEffect(() => {
    if (!consented) return undefined;
    let raf = 0;
    const update = () => {
      raf = 0;
      const hero = document.getElementById('hero-cta');
      const book = document.getElementById('book');
      const vh = window.innerHeight;
      const pastHero = hero ? hero.getBoundingClientRect().bottom < 72 : true; // 72px = fixed header
      let bookOnScreen = false;
      if (book) {
        const r = book.getBoundingClientRect();
        // "On screen" = the booking section fills a real share of the view, not just a sliver at an edge.
        bookOnScreen = Math.min(r.bottom, vh) - Math.max(r.top, 0) > vh * 0.3;
      }
      setShow(pastHero && !bookOnScreen);
      if (pastHero) document.documentElement.classList.add('rb-bookbar');
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
      document.documentElement.classList.remove('rb-bookbar');
    };
  }, [consented]);

  return (
    <div
      className={`rb-bookbar-el md:hidden fixed inset-x-0 bottom-0 z-40 bg-white/95 backdrop-blur-md border-t border-ink/10 shadow-[0_-12px_28px_-20px_rgba(22,26,58,0.45)] px-4 pt-2.5 ${
        show ? 'translate-y-0 visible' : 'translate-y-full invisible'
      }`}
      style={{
        paddingBottom: 'calc(0.625rem + env(safe-area-inset-bottom))',
        transition: 'transform 0.3s ease, visibility 0.3s',
      }}
      aria-hidden={!show}
    >
      <CtaButton className="w-full justify-center" />
    </div>
  );
}
